// Generated, DO NOT EDIT MANUALLY.
import _styles from "#pplx/frontend/aether/components/Skeleton/Skeleton.module.css";

export const styles = _styles;
